import React from 'react'
import PropTypes from 'prop-types'

import web from '../../components/developerApi/developerSdk/GettingStarted/Web/GettingStartedComponent'
import platform from '../../components/developerApi/developerSdk/GettingStarted/Platform/GettingStartedComponent'

import './gettingStartedLayout.scss'

const GETTING_STARTED = {
    web,
    android: platform,
    ios: platform,
}

class GettingStartedLayout extends React.Component {
    render() {
        const api = this.props.api
        const GettingStartedComponent = GETTING_STARTED[api]

        return <div className="getting-started-layout">
            <GettingStartedComponent isAndroid={api === 'android'} />
        </div>
    }
}

GettingStartedLayout.propTypes = {
    api: PropTypes.string.isRequired,
}

export default GettingStartedLayout



// WEBPACK FOOTER //
// ./src/layouts/GettingStarted/GettingStartedLayout.js